// src/pages/About.jsx
import React from "react";
import Section from "../components/Section";

export default function About(){
  return (
    <>
      <Section title="About A & M Audio" subtitle="Veteran-owned. Detail-driven. Customer-obsessed.">
        <div className="grid grid-2-md">
          <div className="card" style={{padding:20}}>
            <p className="muted">After honing skills at leading shops, I founded A &amp; M Audio to deliver clean, reliable installs with precise tuning and factory-quality integration.</p>
            <ul className="small muted" style={{marginTop:12}}>
              <li>Clean, hidden wiring</li>
              <li>Head units, amps, subs, speakers, cameras</li>
              <li>Pro system tuning and demos</li>
            </ul>
          </div>
          <div className="card" style={{padding:20}}>
            <h3 className="h3">Credentials</h3>
            <p className="small muted">Veteran-owned business. Insured. References on request.</p>
          </div>
        </div>
      </Section>
    </>
  );
}
